import { SWReactIcons } from "@similarweb/icons";
import type { GenericGraphProps } from "@similarweb/pro-logic-components";
import { SwLogoTextSVG } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { CompareChart } from "app/pages/sales-intelligence/modules/ai-agent/components/CompareChart/CompareChart";
import { GraphChart } from "app/pages/sales-intelligence/modules/ai-agent/components/GraphChart/GraphChart";
import type {
    ChartObject,
    CompareChartGraphDataItem,
    ChartTrendSeries,
} from "app/pages/sales-intelligence/modules/ai-agent/services/chart/types";
import type { AiAgentEmailAutocompleteCompany } from "app/pages/sales-intelligence/modules/ai-agent/types/email";
import CountryService from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import {
    StyledInsightGraph,
    StyledInsightGraphContainer,
    StyledInsightGraphFooter,
    StyledInsightGraphHeader,
    StyledInsightGraphTitle,
    StyledHeaderInfo,
    StyledHeaderSubtitle,
    StyledCountryFlag,
} from "./styles";

export const AIAgentEmailGraphContent = ({
    chart: chartObject,
    transformedChartData,
    isSimplifiedView = false,
    isCompareChart,
    selectedCompany,
}: {
    chart: ChartObject;
    transformedChartData: ChartTrendSeries[] | CompareChartGraphDataItem[] | GenericGraphProps;
    isSimplifiedView?: boolean;
    isCompareChart: boolean;
    selectedCompany?: AiAgentEmailAutocompleteCompany | null;
}) => {
    const { title, xargs, series } = chartObject;
    return (
        <StyledInsightGraphContainer isCompareChart={isCompareChart}>
            <StyledInsightGraph>
                <StyledInsightGraphHeader>
                    <StyledInsightGraphTitle isSimplifiedView={isSimplifiedView}>{title?.text}</StyledInsightGraphTitle>
                    {!isSimplifiedView ? (
                        <StyledHeaderInfo>
                            <SWReactIcons
                                iconName="daily-ranking"
                                size="xs"
                            />
                            <StyledHeaderSubtitle>{xargs?.date}</StyledHeaderSubtitle>
                            <StyledCountryFlag
                                countryCode={Number(xargs?.country)}
                                size="xs"
                                data-automation-icon-name="flag"
                            />
                            <StyledHeaderSubtitle>
                                {CountryService.getCountryById(xargs?.country || WORLDWIDE_COUNTRY_ID).text}
                            </StyledHeaderSubtitle>
                        </StyledHeaderInfo>
                    ) : null}
                </StyledInsightGraphHeader>
                <Box
                    padding={isCompareChart || isSimplifiedView ? "16px 12px" : "0"}
                    margin={isCompareChart || isSimplifiedView ? "0" : "-24px -4px"}
                >
                    {isCompareChart ? (
                        <CompareChart
                            chartData={transformedChartData as CompareChartGraphDataItem[]}
                            isSimplifiedView={isSimplifiedView}
                            format={series?.[0]?.dataFormat}
                        />
                    ) : (
                        <GraphChart
                            chartData={transformedChartData as ChartTrendSeries[] | GenericGraphProps}
                            chartObject={chartObject}
                            isSimplifiedView={isSimplifiedView}
                            selectedCompany={selectedCompany}
                        />
                    )}
                </Box>
                <StyledInsightGraphFooter>
                    {!isSimplifiedView ? (
                        <>
                            <SWReactIcons
                                iconName="similar-icon"
                                size="7px"
                            />
                            <SwLogoTextSVG />
                        </>
                    ) : null}
                </StyledInsightGraphFooter>
            </StyledInsightGraph>
        </StyledInsightGraphContainer>
    );
};
